import styled from '../../../../styles/theme';
import { PriceBoxStyled } from '../PriceBoxStyled';

export const PriceBoxStyledDS = styled(PriceBoxStyled)`
    .catalogPrice,
    .priceTitle {
        font-size: ${({ theme }) => theme.fontSizes.h5};
        color: ${({ theme }) => theme.colors.grey11};
    }
    .priceBoxWrapper {
        background: rgba(161, 154, 153, 0.1);
    }
    .price {
        .cashPrice,
        .monthlyPrice {
            font-size: ${({ theme }) => theme.fontSizes.h2};
        }
        .priceConjunction {
            span {
                font-size: ${({ theme }) => theme.fontSizes.h5};
                color: ${({ theme }) => theme.colors.grey11};
            }
        }
    }
    .currencyLabel__suffix--OTR,
    .currencyLabel__suffix--PM {
        font-size: ${({ theme }) => theme.fontSizes.h5};
        font-weight: ${({ theme }) => theme.fontWeights.textRegular};
        text-transform: uppercase;
    }
    .aprValue,
    .aprDescription {
        font-size: ${({ theme }) => theme.fontSizes.h5};
        color: ${({ theme }) => theme.colors.primary};
    }
`;
